package com.algorix.web

// UI copy for both languages. Values may contain <code>…</code>, rendered by RichText.
internal object Strings {
    val en: Map<String, String> = mapOf(
        "skip" to "Skip to content",
        "brand.aria" to "AlgoriX, back to top",
        "nav.aria" to "Main",
        "nav.apps" to "Apps",
        "nav.approach" to "Approach",
        "nav.about" to "About",
        "lang.aria" to "Language",
        "hero.eyebrow" to "Independent app studio",
        "hero.l1" to "Small, useful apps.",
        "hero.l2" to "One codebase,",
        "hero.l3" to "two platforms.",
        "hero.lede" to "AlgoriX designs and publishes focused apps for iPhone and Android. Each one is written once with Kotlin Multiplatform, shares its interface through Compose Multiplatform and is built for both the App Store and Google Play.",
        "hero.cta1" to "Explore the apps",
        "hero.cta2" to "How we build",
        "car.aria" to "App screens",
        "car.role" to "carousel",
        "car.slideRole" to "slide",
        "car.hint" to "Drag, swipe or use the arrow keys to turn the carousel.",
        "car.prev" to "Previous screen",
        "car.next" to "Next screen",
        "car.pause" to "Pause rotation",
        "car.play" to "Resume rotation",
        "car.slide" to "Screen {n} of {t}",
        "name.scanme" to "ScanMe",
        "name.vault" to "Vaultly",
        "name.math" to "Basic Math",
        "cat.scanme" to "Utilities",
        "cat.math" to "Education",
        "cat.vault" to "Security",
        "st.scanme" to "On the App Store and Google Play",
        "st.math" to "On the App Store and Google Play",
        "st.vault" to "On Google Play · App Store coming soon",
        "cap.s10" to "Link detail · dark mode",
        "cap.v01" to "Vault list",
        "cap.s04" to "QR code creator",
        "cap.v03" to "Password generator",
        "cap.m01" to "Explorer home",
        "cap.m02" to "Times table with a hint",
        "cap.m04" to "Step-by-step solution",
        "cap.s09" to "Scan history · dark mode",
        "cap.v02" to "Login detail",
        "cap.s01" to "Wi-Fi scan result",
        "sh.s10" to "ScanMe link detail screen in dark mode",
        "sh.s04" to "ScanMe QR code creator with a generated link code",
        "sh.s09" to "ScanMe scan history in dark mode, grouped by day",
        "sh.s01" to "ScanMe scan result for a Wi-Fi QR code, with a button to join the network",
        "sh.s02" to "ScanMe scan history grouped by day",
        "sh.s08" to "Creating a QR code for a Wi-Fi network in ScanMe",
        "sh.v01" to "Vaultly vault list on Android",
        "sh.v02" to "Vaultly login detail showing password strength",
        "sh.v03" to "Vaultly password generator with length and character options",
        "sh.v04" to "Adding an item to Vaultly by camera, screenshot or item type",
        "sh.v05" to "Vaultly security and data settings",
        "sh.m01" to "Basic Math home screen at the Explorer level, with XP progress and game cards",
        "sh.m02" to "Basic Math times table for 7, with a hint and working on the chalkboard",
        "sh.m03" to "Basic Math timed quiz asking 7 × 8, with the answer written on the chalkboard",
        "sh.m04" to "Basic Math teacher showing the full solution step by step after a wrong answer",
        "apps.title" to "Three apps, each doing one job well.",
        "apps.lede" to "A code and document scanner, short math games for young children and an offline password manager.",
        "idx.aria" to "Our apps",
        "store.avail" to "Available on",
        "store.soon" to "Coming soon",
        "newtab" to " (opens in a new tab)",
        "privacy.link" to "Privacy policy",
        "scanme.icon" to "ScanMe app icon",
        "scanme.desc" to "A QR code and barcode scanner, a QR code generator and a document scanner in one app. ScanMe reads codes from the camera or from a photo, creates codes for links, Wi-Fi networks and more, and saves scanned documents as PDFs.",
        "scanme.f1t" to "Scan codes",
        "scanme.f1d" to "QR codes and barcodes, from the camera or from a photo.",
        "scanme.f2t" to "Create QR codes",
        "scanme.f2d" to "For links, Wi-Fi networks and more, ready to share or save.",
        "scanme.f3t" to "Scan documents",
        "scanme.f3d" to "Capture pages and save them as a PDF.",
        "scanme.f4t" to "Wi-Fi and history",
        "scanme.f4d" to "Join a scanned Wi-Fi network directly and find earlier scans in your history.",
        "scanme.m1" to "18 languages",
        "scanme.m2" to "Rare ads, removable with a one-time purchase",
        "scanme.support" to "Support page",
        "math.icon" to "Basic Math app icon",
        "math.cat" to "Education · Ages 4+",
        "math.desc" to "Short math games for ages 4 and up, with a friendly teacher who explains mistakes step by step. No ads, and it works offline.",
        "math.f1t" to "Times tables and quizzes",
        "math.f1d" to "Tables from 1 to 9, and timed quizzes for + − × ÷.",
        "math.f2t" to "Problem solving",
        "math.f2d" to "Problems across 8 topics, with each mistake explained step by step.",
        "math.f3t" to "Puzzles",
        "math.f3d" to "Cross math and balance puzzles.",
        "math.f4t" to "Progress",
        "math.f4d" to "XP, badges and three levels: Little, Explorer and Master.",
        "vault.icon" to "Vaultly app icon",
        "vault.desc" to "An offline password manager. There is no server, no account and no cloud sync, and the Android app does not request the <code>INTERNET</code> permission. Your vault stays encrypted on your phone.",
        "vault.f1t" to "Encrypted on the device",
        "vault.f1d" to "XChaCha20-Poly1305 with a key derived from your master password with Argon2id, using libsodium.",
        "vault.f2t" to "Phone-to-phone transfer",
        "vault.f2d" to "Move your vault between iPhone and Android over an end-to-end encrypted, one-time session.",
        "vault.f3t" to "Scan instead of typing",
        "vault.f3d" to "Read credentials from the camera or a screenshot with on-device text recognition. Images are never stored.",
        "vault.f4t" to "One place for sensitive data",
        "vault.f4d" to "Logins, cards, secure notes, Wi-Fi networks and IDs, with a password generator and strength meter.",
        "vault.m1" to "No server",
        "vault.m2" to "No account",
        "vault.m3" to "Keys in Secure Enclave / Android Keystore",
        "approach.eyebrow" to "Approach",
        "approach.title" to "One Kotlin codebase, two\u00a0native apps.",
        "approach.lede" to "Every AlgoriX app follows the same structure: one shared Kotlin module, a thin platform layer where native APIs are needed, and a separate build for each store.",
        "p1.t" to "Shared by default",
        "p1.d" to "Screens, state, business logic and storage live in <code>shared/commonMain</code>. The interface is written once with Compose Multiplatform and runs on both platforms.",
        "p2.t" to "Native where it matters",
        "p2.d" to "Camera, text recognition and key storage use each platform’s own APIs. Shared code reaches them through <code>expect</code> / <code>actual</code> declarations.",
        "p3.t" to "Two builds, two stores",
        "p3.d" to "Gradle builds the Android app for Google Play and Xcode builds the iOS app for the App Store. A fix made once in shared code reaches both apps.",
        "fig.t1" to "Shared code",
        "fig.t2" to "Platform code",
        "fig.t3" to "Build",
        "fig.t4" to "Distribution",
        "fig.shared" to "Shared Kotlin module",
        "fig.ui" to "Compose Multiplatform UI",
        "fig.logic" to "state and business logic",
        "fig.and" to "Android code",
        "fig.ios" to "iOS code",
        "fig.abuild" to "Android build",
        "fig.ibuild" to "iOS build",
        "fig.cap" to "Figure 1. How an AlgoriX app is structured, built and distributed.",
        "about.title" to "A small studio with a few firm rules.",
        "about.lede" to "AlgoriX is an independent studio that designs, builds and publishes its own apps. Three principles shape every one of them.",
        "a1.t" to "Useful first",
        "a1.d" to "Each app handles one everyday task. A feature is added only when it helps with that task.",
        "a2.t" to "Data stays on the device",
        "a2.d" to "We do the work on the phone wherever we can. Vaultly has no server and no account, and its text recognition runs on the device without storing images.",
        "a3.t" to "Fair pricing",
        "a3.d" to "Basic Math has no ads. In ScanMe, ads are rare and a one-time purchase removes them.",
        "footer.aria" to "Footer",
        "footer.line" to "An independent studio making small, useful apps with Kotlin Multiplatform.",
        "footer.apps" to "Apps",
        "footer.support" to "Support",
        "footer.ssupport" to "ScanMe support",
        "footer.sprivacy" to "ScanMe privacy policy",
        "footer.tm" to "Apple, iPhone and App Store are trademarks of Apple Inc. Google Play and Android are trademarks of Google LLC.",
        "nav.ecommerce" to "E-commerce",
        "footer.ecommerce" to "E-commerce solutions",
        "ec.eyebrow" to "E-commerce solutions",
        "ec.l1" to "Software that runs an online shop end to end.",
        "ec.l2" to "From storefront to shipping, one Kotlin codebase.",
        "ec.lede" to "SellerScope is our order, profit and shipping platform for Etsy and independent sellers. It brings a 3D storefront, marketplace operations, AI tools and shipping into one panel, built with Kotlin, Kobweb and Three.js.",
        "ec.cta1" to "Visit SellerScope",
        "ec.cta2" to "What it does",
        "ec.shot.alt" to "SellerScope dashboard with order totals and recent orders",
        "ec.icon" to "SellerScope app icon",
        "ec.feat.title" to "One panel for the whole shop.",
        "ec.feat.lede" to "Everything a growing shop does every day, from the product page a customer sees to the label on the parcel.",
        "g1.t" to "3D storefront",
        "g1.f1t" to "Live personalization",
        "g1.f1d" to "Customers turn the product, pick a wood colour and see their own engraving on it before anything is cut.",
        "g1.f2t" to "Walkable 3D rooms",
        "g1.f2d" to "Each product stands in its own room, built in code, with drag and WASD controls and a fullscreen mode.",
        "g1.f3t" to "Voice design studio",
        "g1.f3d" to "Customers describe a layout by voice or text. AI edits a size-based layout tree and the code builds the geometry in 2D and 3D.",
        "g2.t" to "Marketplace operations",
        "g2.f1t" to "Order sync",
        "g2.f1d" to "Orders arrive from Etsy over OAuth, and tracking numbers are sent back automatically.",
        "g2.f2t" to "Listings",
        "g2.f2d" to "Draft and update listings, manage inventory and variations, and upload photos to every listing of a product at once.",
        "g2.f3t" to "Performance",
        "g2.f3d" to "Sales and performance per SKU, next to a competitor search.",
        "g3.t" to "AI tools",
        "g3.f1t" to "Listing copy",
        "g3.f1d" to "Titles, descriptions and tags generated from the product.",
        "g3.f2t" to "Review analysis",
        "g3.f2d" to "Customer reviews summarised into what to keep and what to fix.",
        "g3.f3t" to "Inbox assistant",
        "g3.f3d" to "Shipping reports and customs replies are read from email and summarised.",
        "g4.t" to "Shipping, customs and profit",
        "g4.f1t" to "Labels and tracking",
        "g4.f1d" to "Compare carrier rates, create labels and follow every parcel.",
        "g4.f2t" to "Customs",
        "g4.f2d" to "A customs-risk panel and customs documents generated as PDF.",
        "g4.f3t" to "Real profit",
        "g4.f3d" to "Monthly profit and loss from the actual payout and exchange rate, by country, colour and parcel weight.",
        "ec.m1" to "Scheduled sync jobs",
        "ec.m2" to "Order import from CSV",
        "ec.m3" to "English and Turkish",
        "st.eyebrow" to "Platform",
        "st.title" to "Kotlin from the browser to the server.",
        "st.lede" to "SellerScope is one Kotlin codebase. Kobweb renders the interface and serves the API, Three.js draws the 3D scenes, and scheduled jobs keep the marketplace, shipping and accounting in sync.",
        "sp1.t" to "Interface and API together",
        "sp1.d" to "Pages are Kotlin composables, and the server routes live in the same project.",
        "sp2.t" to "3D in the browser",
        "sp2.d" to "Product models, rooms and the design studio render with WebGL, with no plugin to install.",
        "sp3.t" to "Always in sync",
        "sp3.d" to "Data lives in Firebase, and server jobs sync orders, tracking and costs every day.",
        "sf.t1" to "Code",
        "sf.t2" to "Interface",
        "sf.t3" to "Server",
        "sf.t4" to "Services",
        "sf.shared" to "One codebase",
        "sf.web" to "Web interface",
        "sf.3d" to "3D scenes",
        "sf.api" to "API routes",
        "sf.jobs" to "Scheduled jobs",
        "sf.data" to "Data",
        "sf.integrations" to "Integrations",
        "sf.cap" to "Figure 2. How SellerScope is built.",
        "cta.d" to "Order management and analytics for Etsy and independent sellers.",
        "cta.sub" to "Visit",
        "cta.etsy" to "The term “Etsy” is a trademark of Etsy, Inc. This application uses the Etsy API but is not endorsed or certified by Etsy, Inc."
    )

    val tr: Map<String, String> = mapOf(
        "skip" to "İçeriğe geç",
        "brand.aria" to "AlgoriX, başa dön",
        "nav.aria" to "Ana menü",
        "nav.apps" to "Uygulamalar",
        "nav.approach" to "Yaklaşım",
        "nav.about" to "Hakkımızda",
        "lang.aria" to "Dil",
        "hero.eyebrow" to "Bağımsız uygulama stüdyosu",
        "hero.l1" to "Küçük, işe\u00a0yarar uygulamalar.",
        "hero.l2" to "Tek kod tabanı,",
        "hero.l3" to "iki platform.",
        "hero.lede" to "AlgoriX, iPhone ve Android için tek bir işe odaklanan uygulamalar tasarlayıp yayımlıyor. Her biri Kotlin Multiplatform ile bir kez yazılır, arayüzü Compose Multiplatform ile paylaşılır ve hem App Store hem Google Play için hazırlanır.",
        "hero.cta1" to "Uygulamaları keşfedin",
        "hero.cta2" to "Nasıl geliştiriyoruz",
        "car.aria" to "Uygulama ekranları",
        "car.role" to "karusel",
        "car.slideRole" to "slayt",
        "car.hint" to "Döndürmek için sürükleyin, kaydırın ya da ok tuşlarını kullanın.",
        "car.prev" to "Önceki ekran",
        "car.next" to "Sonraki ekran",
        "car.pause" to "Döndürmeyi duraklat",
        "car.play" to "Döndürmeyi sürdür",
        "car.slide" to "Ekran {n} / {t}",
        "name.scanme" to "ScanMe",
        "name.vault" to "Vaultly",
        "name.math" to "Temel Matematik",
        "cat.scanme" to "Araçlar",
        "cat.math" to "Eğitim",
        "cat.vault" to "Güvenlik",
        "st.scanme" to "App Store ve Google Play’de yayında",
        "st.math" to "App Store ve Google Play’de yayında",
        "st.vault" to "Google Play’de yayında · App Store’da yakında",
        "cap.s10" to "Bağlantı ayrıntısı · koyu tema",
        "cap.v01" to "Kasa listesi",
        "cap.s04" to "QR kod oluşturucu",
        "cap.v03" to "Şifre oluşturucu",
        "cap.m01" to "Kaşif ana ekranı",
        "cap.m02" to "İpuçlu çarpım tablosu",
        "cap.m04" to "Adım adım çözüm",
        "cap.s09" to "Tarama geçmişi · koyu tema",
        "cap.v02" to "Giriş ayrıntısı",
        "cap.s01" to "Wi-Fi tarama sonucu",
        "sh.s10" to "Koyu temada ScanMe bağlantı ayrıntısı ekranı",
        "sh.s04" to "ScanMe QR kod oluşturucusunda oluşturulmuş bir bağlantı kodu",
        "sh.s09" to "Koyu temada, güne göre gruplanmış ScanMe tarama geçmişi",
        "sh.s01" to "ScanMe’de bir Wi-Fi QR kodunun tarama sonucu ve ağa bağlanma düğmesi",
        "sh.s02" to "ScanMe’de güne göre gruplanmış tarama geçmişi",
        "sh.s08" to "ScanMe’de bir Wi-Fi ağı için QR kod oluşturma",
        "sh.v01" to "Android’de Vaultly kasa listesi",
        "sh.v02" to "Vaultly’de şifre gücünü gösteren giriş ayrıntısı",
        "sh.v03" to "Vaultly’de uzunluk ve karakter seçenekleriyle şifre oluşturucu",
        "sh.v04" to "Vaultly’ye kamera, ekran görüntüsü ya da öğe türüyle öğe ekleme",
        "sh.v05" to "Vaultly güvenlik ve veri ayarları",
        "sh.m01" to "Kaşif seviyesinde Temel Matematik ana ekranı; XP ilerlemesi ve oyun kartları",
        "sh.m02" to "Temel Matematik’te 7’ler çarpım tablosu; ipucu ve tahtada ara işlem",
        "sh.m03" to "Temel Matematik süreli testinde alt alta toplama sorusu: 64 + 42",
        "sh.m04" to "Temel Matematik öğretmeni, yanlış bir cevaptan sonra çözümü adım adım gösteriyor",
        "apps.title" to "Üç uygulama; her biri tek bir işi iyi yapıyor.",
        "apps.lede" to "Bir kod ve belge tarayıcı, küçük çocuklar için kısa matematik oyunları ve çevrimdışı bir şifre yöneticisi.",
        "idx.aria" to "Uygulamalarımız",
        "store.avail" to "Yayında",
        "store.soon" to "Yakında",
        "newtab" to " (yeni sekmede açılır)",
        "privacy.link" to "Gizlilik politikası",
        "scanme.icon" to "ScanMe uygulama simgesi",
        "scanme.desc" to "QR kod ve barkod tarayıcı, QR kod oluşturucu ve belge tarayıcı tek bir uygulamada. ScanMe kodları kameradan ya da bir fotoğraftan okur; bağlantılar, Wi-Fi ağları ve daha fazlası için kod oluşturur, taranan belgeleri PDF olarak kaydeder.",
        "scanme.f1t" to "Kod tarama",
        "scanme.f1d" to "QR kod ve barkodlar; kameradan ya da bir fotoğraftan.",
        "scanme.f2t" to "QR kod oluşturma",
        "scanme.f2d" to "Bağlantılar, Wi-Fi ağları ve daha fazlası için; paylaşmaya ya da kaydetmeye hazır.",
        "scanme.f3t" to "Belge tarama",
        "scanme.f3d" to "Sayfaları tarayın ve PDF olarak kaydedin.",
        "scanme.f4t" to "Wi-Fi ve geçmiş",
        "scanme.f4d" to "Taradığınız Wi-Fi ağına doğrudan bağlanın, önceki taramalarınızı geçmişte bulun.",
        "scanme.m1" to "18 dil",
        "scanme.m2" to "Çok seyrek reklam; tek seferlik satın alımla kaldırılabilir",
        "scanme.support" to "Destek sayfası",
        "math.icon" to "Temel Matematik uygulama simgesi",
        "math.cat" to "Eğitim · 4 yaş ve üzeri",
        "math.desc" to "4 yaş ve üzeri için kısa matematik oyunları ve yanlışları adım adım açıklayan sevimli bir öğretmen. Reklam yok, internetsiz de çalışır.",
        "math.f1t" to "Çarpım tablosu ve testler",
        "math.f1d" to "1’den 9’a çarpım tablosu; + − × ÷ için süreli testler.",
        "math.f2t" to "Problem çözme",
        "math.f2d" to "8 konuda problemler; her yanlış adım adım açıklanır.",
        "math.f3t" to "Bulmacalar",
        "math.f3d" to "Çapraz matematik ve terazi bulmacaları.",
        "math.f4t" to "İlerleme",
        "math.f4d" to "XP, rozetler ve üç seviye: Minik, Kaşif ve Usta.",
        "vault.icon" to "Vaultly uygulama simgesi",
        "vault.desc" to "Çevrimdışı bir şifre yöneticisi. Sunucu, hesap ya da bulut eşitleme yok; Android uygulaması <code>INTERNET</code> izni bile istemiyor. Kasanız telefonunuzda şifreli olarak durur.",
        "vault.f1t" to "Cihazda şifreleme",
        "vault.f1d" to "libsodium ile XChaCha20-Poly1305; anahtar, ana şifrenizden Argon2id ile türetilir.",
        "vault.f2t" to "Telefondan telefona aktarım",
        "vault.f2d" to "Kasanızı iPhone ile Android arasında, uçtan uca şifreli tek seferlik bir oturumla taşıyın.",
        "vault.f3t" to "Yazmak yerine tarayın",
        "vault.f3d" to "Giriş bilgilerini kameradan ya da bir ekran görüntüsünden, cihaz üzerinde metin tanımayla okuyun. Görüntüler asla saklanmaz.",
        "vault.f4t" to "Hassas veriler tek yerde",
        "vault.f4d" to "Giriş bilgileri, kartlar, güvenli notlar, Wi-Fi ağları ve kimlikler; şifre oluşturucu ve şifre gücü ölçerle birlikte.",
        "vault.m1" to "Sunucu yok",
        "vault.m2" to "Hesap yok",
        "vault.m3" to "Anahtarlar Secure Enclave / Android Keystore’da",
        "approach.eyebrow" to "Yaklaşım",
        "approach.title" to "Tek Kotlin kod\u00a0tabanı, iki\u00a0platforma özgü uygulama.",
        "approach.lede" to "Her AlgoriX uygulaması aynı yapıyı izler: tek bir ortak Kotlin modülü, yalnızca yerel API’ler gerektiğinde devreye giren ince bir platform katmanı ve her mağaza için ayrı bir derleme.",
        "p1.t" to "Varsayılan olarak ortak",
        "p1.d" to "Ekranlar, durum, iş mantığı ve veri katmanı <code>shared/commonMain</code> içinde yer alır. Arayüz Compose Multiplatform ile bir kez yazılır ve iki platformda da çalışır.",
        "p2.t" to "Gereken yerde platforma özgü",
        "p2.d" to "Kamera, metin tanıma ve anahtar saklama her platformun kendi API’lerini kullanır. Ortak kod bunlara <code>expect</code> / <code>actual</code> bildirimleriyle ulaşır.",
        "p3.t" to "İki derleme, iki mağaza",
        "p3.d" to "Gradle, Google Play için Android uygulamasını; Xcode ise App Store için iOS uygulamasını derler. Ortak kodda bir kez yapılan düzeltme iki uygulamaya da ulaşır.",
        "fig.t1" to "Ortak kod",
        "fig.t2" to "Platform kodu",
        "fig.t3" to "Derleme",
        "fig.t4" to "Dağıtım",
        "fig.shared" to "Ortak Kotlin modülü",
        "fig.ui" to "Compose Multiplatform arayüzü",
        "fig.logic" to "durum ve iş mantığı",
        "fig.and" to "Android kodu",
        "fig.ios" to "iOS kodu",
        "fig.abuild" to "Android derlemesi",
        "fig.ibuild" to "iOS derlemesi",
        "fig.cap" to "Şekil 1. Bir AlgoriX uygulamasının yapısı, derlenmesi ve dağıtımı.",
        "about.title" to "Birkaç net kuralı olan küçük bir stüdyo.",
        "about.lede" to "AlgoriX, kendi uygulamalarını tasarlayan, geliştiren ve yayımlayan bağımsız bir stüdyo. Her birine üç ilke yön veriyor.",
        "a1.t" to "Önce fayda",
        "a1.d" to "Her uygulama gündelik tek bir işi üstlenir. Bir özellik ancak o işe yardım ediyorsa eklenir.",
        "a2.t" to "Veriler cihazda kalır",
        "a2.d" to "Yapabildiğimiz her işi telefonda yaparız. Vaultly’nin sunucusu da hesabı da yoktur; metin tanıma cihazda çalışır ve görüntüleri saklamaz.",
        "a3.t" to "Adil fiyatlandırma",
        "a3.d" to "Temel Matematik reklamsızdır. ScanMe’de reklamlar çok seyrektir ve tek seferlik bir satın alımla kaldırılabilir.",
        "footer.aria" to "Alt bilgi",
        "footer.line" to "Kotlin Multiplatform ile küçük ve işe yarar uygulamalar yapan bağımsız bir stüdyo.",
        "footer.apps" to "Uygulamalar",
        "footer.support" to "Destek",
        "footer.ssupport" to "ScanMe desteği",
        "footer.sprivacy" to "ScanMe gizlilik politikası",
        "footer.tm" to "Apple, iPhone ve App Store, Apple Inc.’in ticari markalarıdır. Google Play ve Android, Google LLC’nin ticari markalarıdır.",
        "nav.ecommerce" to "E-Ticaret",
        "footer.ecommerce" to "E-ticaret çözümleri",
        "ec.eyebrow" to "E-ticaret çözümleri",
        "ec.l1" to "Bir online mağazayı uçtan uca yöneten yazılım.",
        "ec.l2" to "Vitrinden kargoya, tek Kotlin kod\u00a0tabanı.",
        "ec.lede" to "SellerScope, Etsy ve bağımsız satıcılar için geliştirdiğimiz sipariş, kâr ve kargo platformu. 3D vitrini, pazaryeri operasyonlarını, yapay zekâ araçlarını ve kargoyu tek panelde toplar; Kotlin, Kobweb ve Three.js ile geliştirildi.",
        "ec.cta1" to "SellerScope’a git",
        "ec.cta2" to "Neler yapıyor",
        "ec.shot.alt" to "Sipariş özetleri ve son siparişlerle SellerScope paneli",
        "ec.icon" to "SellerScope uygulama simgesi",
        "ec.feat.title" to "Mağazanın tamamı için tek panel.",
        "ec.feat.lede" to "Büyüyen bir mağazanın her gün yaptığı her şey: müşterinin gördüğü ürün sayfasından kolinin üzerindeki etikete kadar.",
        "g1.t" to "3D vitrin",
        "g1.f1t" to "Canlı kişiselleştirme",
        "g1.f1d" to "Müşteri ürünü döndürür, ahşap rengini seçer ve kesimden önce kendi gravürünü ürünün üzerinde görür.",
        "g1.f2t" to "Gezilebilir 3D odalar",
        "g1.f2d" to "Her ürün kodla kurulmuş kendi odasında durur; sürükleyerek ya da WASD ile gezilir, tam ekran açılır.",
        "g1.f3t" to "Sesli tasarım stüdyosu",
        "g1.f3d" to "Müşteri istediği düzeni sesle ya da yazarak anlatır. Yapay zekâ ölçü tabanlı yerleşim ağacını düzenler, geometriyi kod 2D ve 3D olarak üretir.",
        "g2.t" to "Pazaryeri operasyonları",
        "g2.f1t" to "Sipariş senkronu",
        "g2.f1d" to "Siparişler OAuth ile Etsy’den gelir, takip numaraları otomatik olarak geri gönderilir.",
        "g2.f2t" to "İlanlar",
        "g2.f2d" to "İlan taslağı oluşturun ve güncelleyin, stok ve varyasyonları yönetin, bir ürünün tüm ilanlarına fotoğrafları tek seferde yükleyin.",
        "g2.f3t" to "Performans",
        "g2.f3d" to "SKU bazında satış ve performans, yanında rakip araması.",
        "g3.t" to "Yapay zekâ araçları",
        "g3.f1t" to "İlan metni",
        "g3.f1d" to "Üründen başlık, açıklama ve etiket üretimi.",
        "g3.f2t" to "Yorum analizi",
        "g3.f2d" to "Müşteri yorumları, korunacak ve düzeltilecek noktalar olarak özetlenir.",
        "g3.f3t" to "Gelen kutusu asistanı",
        "g3.f3d" to "Kargo raporları ve gümrük yanıtları e-postadan okunur ve özetlenir.",
        "g4.t" to "Kargo, gümrük ve kâr",
        "g4.f1t" to "Etiket ve takip",
        "g4.f1d" to "Taşıyıcı fiyatlarını karşılaştırın, etiket oluşturun ve her koliyi takip edin.",
        "g4.f2t" to "Gümrük",
        "g4.f2d" to "Gümrük risk paneli ve PDF olarak üretilen gümrük belgeleri.",
        "g4.f3t" to "Gerçek kâr",
        "g4.f3d" to "Gerçek ödeme ve kur üzerinden aylık kâr-zarar; ülke, renk ve koli ağırlığına göre.",
        "ec.m1" to "Zamanlanmış senkron işleri",
        "ec.m2" to "CSV’den sipariş aktarımı",
        "ec.m3" to "Türkçe ve İngilizce",
        "st.eyebrow" to "Altyapı",
        "st.title" to "Tarayıcıdan sunucuya Kotlin.",
        "st.lede" to "SellerScope tek bir Kotlin kod tabanıdır. Arayüzü ve API’yi Kobweb sunar, 3D sahneleri Three.js çizer, zamanlanmış işler pazaryeri, kargo ve muhasebeyi senkron tutar.",
        "sp1.t" to "Arayüz ve API bir arada",
        "sp1.d" to "Sayfalar Kotlin composable’larıdır; sunucu uçları da aynı projede yer alır.",
        "sp2.t" to "Tarayıcıda 3D",
        "sp2.d" to "Ürün modelleri, odalar ve tasarım stüdyosu WebGL ile çalışır; eklenti kurmak gerekmez.",
        "sp3.t" to "Her zaman senkron",
        "sp3.d" to "Veriler Firebase’de durur; sunucu işleri siparişleri, takibi ve maliyetleri her gün senkronlar.",
        "sf.t1" to "Kod",
        "sf.t2" to "Arayüz",
        "sf.t3" to "Sunucu",
        "sf.t4" to "Servisler",
        "sf.shared" to "Tek kod tabanı",
        "sf.web" to "Web arayüzü",
        "sf.3d" to "3D sahneler",
        "sf.api" to "API uçları",
        "sf.jobs" to "Zamanlanmış işler",
        "sf.data" to "Veri",
        "sf.integrations" to "Entegrasyonlar",
        "sf.cap" to "Şekil 2. SellerScope’un yapısı.",
        "cta.d" to "Etsy ve bağımsız satıcılar için sipariş yönetimi ve analitik.",
        "cta.sub" to "Ziyaret edin",
        "cta.etsy" to "“Etsy” ifadesi Etsy, Inc.’in ticari markasıdır. Bu uygulama Etsy API’sini kullanır ancak Etsy, Inc. tarafından onaylanmış ya da sertifikalandırılmış değildir."
    )
}
